export default __webpack_public_path__ + "static/media/SC.b7d16bc8.svg";